







































/* eslint-disable */
import { Component, Vue, Prop } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import Details from "./Details.vue";
import Log from "./Log.vue";
import DiscardModal from "./DiscardModal.vue";

@Component({
  components: {
    Details,
    Log,
    DiscardModal
  }
})
export default class EditAccount extends Vue {
  private user = {
    firstName: "",
    lastName: "",
    extension: "",
    description: "",
    accountId: null,
    accountStatus: false
  };

  private title = "";

  private tab = "";
  private tabs = [
    { tab: "Details", content: "Details" },
    { tab: "Log", content: "Log" }
  ];

  private discardModalFlag = false;
  private triggerDiscardModal = false;

  @Prop() readonly value!: boolean;

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    EventBus.$emit("closeEditAccountModal", value);
  }

  created() {
    EventBus.$on("openEditAccountModal", (user: any) => {
      this.triggerDiscardModal = false;

      this.title = `Edit ${user.firstName} ${user.lastName}`;
      this.user = {
        firstName: user.firstName,
        lastName: user.lastName,
        extension: user.extension,
        description: user.description,
        accountId: user.accountId,
        accountStatus: user.accountStatus
      };
      this.tab = "Details";
    });

    EventBus.$on("closeDiscardModal", (value: boolean) => {
      this.discardModalFlag = value;
    });

    EventBus.$on("triggerDiscardModal", (value: boolean) => {
      this.triggerDiscardModal = value;
    });
  }


  beforeDestroy () {
    EventBus.$off('openEditAccountModal')
    EventBus.$off('closeDiscardModal')
    EventBus.$off('triggerDiscardModal')
  }
  // close modal and clear input fields
  private cancel(): void {
    if (this.triggerDiscardModal) {
      //show discard modal
      this.discardModalFlag = true;
    } else {
      this.tab = "Details";
      this.show = false;
      this.user = {
        firstName: "",
        lastName: "",
        extension: "",
        description: "",
        accountId: null,
        accountStatus: false
      };
    }
    EventBus.$emit("LogSocketClose", null);
  }
}
